module.exports = __webpack_public_path__ + "static/media/6.99e0eef9.jpg";